import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Set locale files

import GlobalLocale from '@/global/locales/index';
import PagesLocale from '@/global/locales/pages';
import LayoutLocale from '@/global/locales/layout';

import StudentsLocale from '@/taskflex/students/locales/index';
import SkillsLocale from '@/taskflex/skills/locales/index';
import LevelsLocale from '@/taskflex/levels/locales/index';
import CustomersLocale from '@/taskflex/customers/locales/index';
import UsersLocale from '@/taskflex/users/locales/index';
import ProjectsLocale from '@/taskflex/projects/locales/index';

const localeFiles = {
    GlobalLocale,
    PagesLocale,
    LayoutLocale,
    StudentsLocale,
    SkillsLocale,
    LevelsLocale,
    CustomersLocale,
    UsersLocale,
    ProjectsLocale,
};

// Set configuration - TODO: move to types file, and use in locale files.
const DANISH_CODE = 'da';
const ENGLISH_CODE = 'en';

const config = {
    locale: DANISH_CODE,
    fallbackLocale: ENGLISH_CODE,
    enabled: [
        DANISH_CODE,
        ENGLISH_CODE,
    ],
};

/**
 * Extracts and converts locales to the correct format
 * TODO: Find and Load dynamically as a webpack step
 */
function loadLocales() {
    const messages = {};

    Object.values(localeFiles).forEach((locale) => {
        config.enabled.forEach((localeShort) => {
            if (!messages[localeShort]) {
                messages[localeShort] = {};
            }

            messages[localeShort][locale.namespace] = locale[localeShort];
        });
    });

    return messages;
}

/**
 * Initializes the locale library
 */
const initialize = () => {
    Vue.use(VueI18n);

    // Iterate language files and merge them
    const messages = loadLocales();

    // eslint-disable-next-line no-unused-vars
    return new VueI18n({
        locale: config.locale,
        fallbackLocale: config.fallbackLocale,
        messages,
        numberFormats: {
            [DANISH_CODE]: {
                currency: {
                    style: 'currency', currency: 'DKK', minimumFractionDigits: 0,
                },
            },
            [ENGLISH_CODE]: {
                currency: {
                    style: 'currency', currency: 'USD',
                },
            },
        },
    });
};

export default {
    initialize,
};



// WEBPACK FOOTER //
// ./src/services/LocalizationService.js